document.addEventListener('DOMContentLoaded', function () {
  function initInfiniteScroll(grid) {
    var sentinel = document.querySelector('[data-ec-infinite-sentinel]');
    var loadingIndicator = document.querySelector('[data-ec-infinite-loading]');
    var nextUrl = grid.getAttribute('data-next-url');
    var isLoading = false;

    if (!nextUrl || !sentinel) return;

    function loadNextPage() {
      if (isLoading || !nextUrl) return;
      isLoading = true;
      if (loadingIndicator) loadingIndicator.hidden = false;

      fetch(nextUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-ec-infinite-grid]');

          if (newGrid) {
            var newItems = newGrid.querySelectorAll('.grid__item');
            var existingIds = new Set();
            grid.querySelectorAll('.grid__item[data-product-id]').forEach(function (item) {
              existingIds.add(item.getAttribute('data-product-id'));
            });

            newItems.forEach(function (item) {
              var productId = item.getAttribute('data-product-id');
              if (!productId || !existingIds.has(productId)) {
                grid.appendChild(item);
              }
            });

            nextUrl = newGrid.getAttribute('data-next-url');
            grid.setAttribute('data-next-url', nextUrl || '');
          } else {
            nextUrl = null;
          }

          isLoading = false;
          if (loadingIndicator) loadingIndicator.hidden = true;

          if (!nextUrl) {
            observer.disconnect();
            if (sentinel) sentinel.hidden = true;
          }
        })
        .catch(function () {
          isLoading = false;
          if (loadingIndicator) loadingIndicator.hidden = true;
        });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadNextPage();
          }
        });
      },
      { rootMargin: '600px 0px 600px 0px' }
    );

    observer.observe(sentinel);
  }

  var grid = document.querySelector('[data-ec-infinite-grid]');
  if (grid) {
    initInfiniteScroll(grid);
  }
});
